import { useTranslation } from 'react-i18next';
import LabelWithTooltip from '../LabelWithTooltip';

export type LabelProps = {
	tooltipId?: string;
	tooltipText?: string;
	label: string;
	name: string;
	children?: React.ReactNode;
	required?: boolean;
	htmlFor?: string;
	disabled?: boolean;
	endAdornment?: React.ReactNode;
	infoCopy?: React.ReactNode;
	inline?: boolean;
};

const Label = ({
	tooltipId,
	tooltipText,
	label,
	name,
	children,
	required,
	htmlFor,
	disabled,
	endAdornment,
	infoCopy,
	inline,
}: LabelProps) => {
	const { t } = useTranslation();
	return (
		<>
			{!tooltipId && !tooltipText && (
				<label
					className={
						'block mb-2 first-letter-uppercase relative' +
						(disabled ? ' opacity-50 cursor-not-allowed' : '')
					}
					htmlFor={htmlFor || name}
				>
					<span className={inline ? 'flex items-center gap-2' : ''}>
						<span className='first-letter-uppercase inline-block'>{t(label)}</span>
						{required && <span className='ml-1 text-sm'>*</span>}
						{inline && children && <span>{children}</span>}
					</span>
					{infoCopy && (
						<span className='block text-xs text-tertiary first-letter-uppercase my-2'>
							{infoCopy}
						</span>
					)}

					{!inline && children && <span className='block'>{children}</span>}

					{endAdornment && (
						<div
							className='absolute right-3 top-1/2 -translate-y-1/2 flex items-center gap-1'
							aria-hidden={true}
						>
							{endAdornment}
						</div>
					)}
				</label>
			)}

			{tooltipId && tooltipText && (
				<LabelWithTooltip
					label={label}
					tooltipId={tooltipId}
					tooltipText={tooltipText}
					name={name}
					htmlFor={htmlFor}
					required={required}
				/>
			)}
		</>
	);
};

export default Label;
